import { render, staticRenderFns } from "./CancelReviewProcessPopup.vue?vue&type=template&id=79a40cbe&"
import script from "./CancelReviewProcessPopup.vue?vue&type=script&lang=js&"
export * from "./CancelReviewProcessPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports